let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3kD5G")).then(() => parcelRequire('lglbZ'));